export default __webpack_public_path__ + "static/openingDoor-b3968f541c527c6e2769f9806b25febe.svg";